import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconAdminPanel = ({
  title = "Admin Panel",
  color = "gray",
  viewBoxWidth = 34,
  viewBoxHeight = 34,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g id="IconAdminPanel" strokeWidth="1">
      <path
        d="M13,20 C13.5522847,20 14,20.4477153 14,21 L14,33 C14,33.5522847 13.5522847,34 13,34 L1,34 C0.44771525,34 0,33.5522847 0,33 L0,21 C0,20.4477153 0.44771525,20 1,20 L13,20 Z M33,20 C33.5522847,20 34,20.4477153 34,21 L34,33 C34,33.5522847 33.5522847,34 33,34 L17,34 C16.4477153,34 16,33.5522847 16,33 L16,21 C16,20.4477153 16.4477153,20 17,20 L33,20 Z M12,22 L2,22 L2,32 L12,32 L12,22 Z M32,22 L18,22 L18,32 L32,32 L32,22 Z M30,28 L30,30 L20,30 L20,28 L30,28 Z M30,24 L30,26 L20,26 L20,24 L30,24 Z M33,0 C33.5522847,0 34,0.44771525 34,1 L34,17 C34,17.5522847 33.5522847,18 33,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,1 C0,0.44771525 0.44771525,0 1,0 L33,0 Z M32,2 L2,2 L2,16 L32,16 L32,2 Z M6,10 L6,14 L4,14 L4,10 L6,10 Z M10,8 L10,14 L8,14 L8,8 L10,8 Z M14,5 L14,14 L12,14 L12,5 L14,5 Z M18,4 L18,14 L16,14 L16,4 L18,4 Z M22,7 L22,14 L20,14 L20,7 L22,7 Z M26,5 L26,14 L24,14 L24,5 L26,5 Z M30,7 L30,14 L28,14 L28,7 L30,7 Z"
        fill={uiColorToBaseColor(color)}
      />
    </g>
  </Svg.Icon>
)

export default IconAdminPanel
